import React from 'react';
import MessageButtonCard from '../../../../shared/components/react/MessageButtonCard';
import { useTranslation } from 'react-i18next';
import {
    NO_MARKETS_BUTTON_LINK,
    I18N_NO_MARKETS_BUTTON,
    I18N_NO_MARKETS_MESSAGE,
    NO_RESULTS_ICON,
} from './constants';

const NoMarkets = () => {
    const [ t ] = useTranslation();

        return (
            <MessageButtonCard
                MessageIconClassName={NO_RESULTS_ICON}
                message={t(I18N_NO_MARKETS_MESSAGE)}
                button={t(I18N_NO_MARKETS_BUTTON)}
                link={NO_MARKETS_BUTTON_LINK}
            />
        );
    };

export default NoMarkets;
